/** saves Accounts Balances
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_BALANCE = (state, payload) => {
    state.accountsBalances = payload.balanceViews
}

/** saves Accounts Movements
@payload { Array } - list of movements for selected account
*/
export const SAVE_ACCOUNTS_MOVEMENTS = (state, { pageNumber, data }) => {
    state.accountsMovements = pageNumber === 1 ? data.movements : state.accountsMovements.concat(data.movements)

    state.lastMovementInfo = {
        releaseDatePosition: data.releaseDatePosition,
        orderNumberPosition: data.orderNumberPosition
    }
    state.movementsHasMore = data.hasMore
}

/** saves Movements Categories
@payload { Array } -list of categories
*/
export const SAVE_CATEGORIES = (state, payload) => {
    state.movementsCategories = payload
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
    state.accountsBalances = []
    state.accountsMovements = []
    state.lastMovementInfo = {}
    state.movementsHasMore = false
    state.movementsCategories = []
}
